export default {
  approvementStatus: 0,
};
